import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "replaceSpaces",
    standalone: false
})
export class ReplaceSpacesPipe implements PipeTransform {
  transform(value: string): string {
    return value && value.replace(/ /g, "");
  }
}
